import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, Button, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import L from 'leaflet';

const PlaceSearch = ({ setCenter, setZoom }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const theme = useTheme();
    const searchBoxRef = useRef(null);

    useEffect(() => {
        if (searchBoxRef.current) {
            L.DomEvent.disableClickPropagation(searchBoxRef.current);
            L.DomEvent.disableScrollPropagation(searchBoxRef.current);
        }
    }, []);

    const handleSearch = async () => { 
        if (!searchQuery) return;

        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}`);
            const data = await response.json();

            if (data && data.length > 0) {
                const { lat, lon } = data[0];
                setCenter([parseFloat(lat), parseFloat(lon)]);
                setZoom(8);
            }else {
                alert("Location not found. Please try a different search term.");
            }
        } catch (error) {
            console.error("Error searching for location:", error);
            alert("An error ocurred while searching for the location. Please try again.");
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <Box 
        ref={searchBoxRef}
        sx={{
            position: "absolute",
            top: 15,
            right: 80,
            zIndex: 1000,
            backgroundColor: theme.palette.primary.white,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center'
          }}
          >
            <TextField
            size='small'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder='Search for a place...'
            onKeyDown={handleKeyDown}
            />
            <Button 
            variant='contained' 
            onClick={handleSearch} 
            sx={{minWidth: '20px', padding: '6px 10px'}}>
                <SearchIcon/>
            </Button>
        </Box>
    )
}

export default PlaceSearch;